import React from 'react';
import { cn } from '../../utils/cn';

export function Alert({ children, className, ...props }) {
  return (
    <div
      className={cn(
        'relative rounded-lg border p-4',
        className
      )}
      {...props}
    >
      {children}
    </div>
  );
}

export function AlertDescription({ children, className, ...props }) {
  return (
    <div className={cn('text-sm', className)} {...props}>
      {children}
    </div>
  );
}

